// @ts-check

import { dbGet, dbPostWithFormData } from "utils/DBFetchers";

/** @typedef {{ data: Array<{ period: number, enrolled_pharmacies: number, active_pharmacies: number, new_pharmacies_with_sales: number }>, output_files: Record<string, string> }} IndependentPharmacyActivityResponse */

export const INDEPENDENT_PHARMACY_ACTIVITY_ENDPOINT =
  "cli/threads/reporte_actividad_independientes";

const REQUEST_CHECKER_STATUS_ENDPOINT = "request_checker/status";

/**
 * @param {number} fromPeriod
 * @param {number} toPeriod
 * @returns {Promise<{ id: string | number }>}
 */
export async function startIndependentPharmacyActivityThread(
  fromPeriod,
  toPeriod,
) {
  const formData = new FormData();
  formData.append("from_period", String(fromPeriod));
  formData.append("to_period", String(toPeriod));
  const response = await dbPostWithFormData(
    INDEPENDENT_PHARMACY_ACTIVITY_ENDPOINT,
    formData,
  );
  const requestId = response?.id || response?.import_id;

  if (!requestId) {
    throw new Error("No se pudo iniciar el reporte: respuesta inválida.");
  }

  return { id: requestId };
}

/**
 * @param {string | number} id
 * @returns {Promise<any>}
 */
export function getIndependentPharmacyActivityThreadStatus(id) {
  return dbGet(
    `${REQUEST_CHECKER_STATUS_ENDPOINT}?id=${encodeURIComponent(id)}`,
  );
}

/**
 * @param {any} response
 * @returns {IndependentPharmacyActivityResponse}
 */
export function mapCompletedIndependentPharmacyActivityThread(response) {
  const reportData = response?.data?.report_data;

  if (!Array.isArray(reportData)) {
    throw new Error(
      "El reporte finalizó, pero los datos de resumen recibidos no son válidos.",
    );
  }

  return {
    data: reportData,
    output_files: response?.data?.output_files || {},
  };
}
